/**
 * 外链直跳告警详情：URL 参数解析与会话标记
 *
 * 外链 URL 示例：
 *   /#/{project_id}/alarm/detail/{alarm_id}?app_token=xxx&projectName=xxx&userRole=admin
 */

/** 告警详情路由名 */
export const ALARM_DETAIL_ROUTE_NAME = 'alarm-new-detail'

/** URL 是否携带 app_token 且目标为告警详情页 */
export function isExternalEntryFromUrl(to) {
  return !!(to.query?.app_token && to.name === ALARM_DETAIL_ROUTE_NAME)
}

/** 当前会话是否由外链进入（守卫处理 app_token 后写入 store） */
export function isExternalEntry() {
  return !!window.$store?.isExternalEntry
}

/** app_token 写入 localStorage */
export function syncTokenFromUrl(to) {
  const appToken = to.query?.app_token
  if (appToken) {
    localStorage.setItem('token', String(appToken))
    window.$store.isApp = true
  }
}

/** path project_id + query projectName 写入 currentProject（不调接口） */
export function syncProjectFromExternalUrl(to) {
  const projectId = to.params?.project_id
  if (!projectId) return

  const projectName =
    to.query?.projectName || to.query?.project_name || ''

  window.$store.currentProject = {
    id: String(projectId),
    name: String(projectName),
  }
}

/** query userRole 写入 userInfo.sys_role（不调 userinfo 接口） */
export function syncUserRoleFromExternalUrl(to) {
  const userRole =
    to.query?.userRole || to.query?.user_role || to.query?.sys_role || ''
  if (!userRole) return

  window.$store.userInfo = {
    ...window.$store.userInfo,
    sys_role: String(userRole),
    id: window.$store.userInfo?.id || 'external',
  }
}

/** 标记当前会话为外链进入 */
export function markExternalEntry() {
  window.$store.isExternalEntry = true
  window.$store.isApp = true
}

/**
 * App 事件 payload 同步上下文（project_id / project_name / app_token）
 * @returns {boolean} 是否更新了上下文
 */
export function syncAppContextFromPayload(payload) {
  if (!payload || typeof payload !== 'object') return false

  const projectId = payload.project_id
  const projectName = payload.project_name ?? payload.projectName
  const appToken = payload.app_token

  if (!projectId && !projectName && !appToken) return false

  if (appToken) {
    localStorage.setItem('token', String(appToken))
    window.$store.isApp = true
  }
  if (projectId || projectName != null) {
    window.$store.currentProject = {
      id: projectId
        ? String(projectId)
        : String(window.$store.currentProject?.id || ''),
      name:
        projectName != null
          ? String(projectName)
          : String(window.$store.currentProject?.name || ''),
    }
  }
  return true
}

/**
 * 组装 App 原生详情页参数（字段与外链 URL 一致）
 * path: project_id, alarm_id
 * query: app_token, projectName, userRole
 * 另附 row 供原生页直接渲染
 */
export function buildAppDetailPayload(row) {
  if (!row) return null

  const project = window.$store?.currentProject || {}
  const userInfo = window.$store?.userInfo || {}

  return {
    project_id: String(project.id || ''),
    projectName: String(project.name || ''),
    alarm_id: String(row.id),
    app_token: localStorage.getItem('token') || '',
    userRole: String(userInfo.sys_role || ''),
  }
}

/** 外链 / App 内嵌：跳转原生告警详情 */
export function goToAppDetail(row) {
  const payload = buildAppDetailPayload(row)
  if (!payload) return
  window.AIOTBridge?.goToDetail?.(payload)
}
